import { MenuItem, Skeleton, TextField } from '@mui/material';
import { ChangeEvent } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';

import { useClientServiceProviders } from 'hooks/useClientServiceProviders';
import useTranslate from 'hooks/useTranslate';

const OrganizationSelector = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { id } = useParams();
    const { translate } = useTranslate();
    const { data: serviceProviderOptions = [], isFetching } = useClientServiceProviders({
        enabled: Boolean(id),
        excludeOwnServiceProvider: true,
    });

    const handleServiceProviderChange = (event: ChangeEvent<HTMLInputElement>) => {
        const nextServiceProviderId = event.target.value;

        if (!nextServiceProviderId || nextServiceProviderId === id) {
            return;
        }

        const nextPath = location.pathname.replace(
            /^\/dashboard\/[^/]+/,
            `/dashboard/${nextServiceProviderId}`
        );

        navigate(
            nextPath !== location.pathname
                ? `${nextPath}${location.search}${location.hash}`
                : `/dashboard/${nextServiceProviderId}${location.search}${location.hash}`
        );
    };

    if (isFetching && serviceProviderOptions.length < 2) {
        return <Skeleton variant="rounded" width={220} height={40} />;
    }

    if (serviceProviderOptions.length < 2) {
        return null;
    }

    const selectValue = serviceProviderOptions.some((option) => String(option.value) === String(id))
        ? String(id)
        : '';

    return (
        <TextField
            select
            size="small"
            label={translate('organization')}
            value={selectValue}
            onChange={handleServiceProviderChange}
            sx={{ minWidth: { xs: '100%', sm: 240 } }}
        >
            {serviceProviderOptions.map((option) => (
                <MenuItem key={String(option.value)} value={String(option.value)}>
                    {option.label}
                </MenuItem>
            ))}
        </TextField>
    );
};

export default OrganizationSelector;
